import type { EditBookingFormValues } from '../../../utils/editBookingValidation'

/** フォーム入力値から作業時間（分）の表示文字列を算出。日跨ぎ対応。 */
export const computeWorkingTimeLabel = (values: EditBookingFormValues): string => {
  const { startDate, startTime, endDate, endTime } = values
  if (!startDate || !startTime || !endDate || !endTime) return '-'
  const start = new Date(`${startDate}T${startTime}`)
  const end = new Date(`${endDate}T${endTime}`)
  const diffMinutes = Math.floor((end.getTime() - start.getTime()) / 60000)
  if (!Number.isFinite(diffMinutes) || diffMinutes <= 0) return '-'
  return `${diffMinutes}分`
}

/** 00:00〜23:55 を 5 分刻みで生成（HH:mm）。 */
const TIME_OPTIONS: readonly string[] = Array.from({ length: 24 }, (_, h) =>
  Array.from(
    { length: 12 },
    (_, i) => `${String(h).padStart(2, '0')}:${String(i * 5).padStart(2, '0')}`
  )
).flat()

/** 既存値が 5 分刻みに合わない場合に備えて、現在値を先頭にマージ。 */
export const buildTimeOptions = (current: string): readonly string[] =>
  current && !TIME_OPTIONS.includes(current) ? [current, ...TIME_OPTIONS] : TIME_OPTIONS
